import { TimerEntry } from './persisted-timer.models';
import { OTP_TIMERS_STORAGE_KEY } from '../../constants/one-time-pin';

const MAX_ENTRIES = 10;

export function getTimerEntries(): TimerEntry[] {
  try {
    const raw = localStorage.getItem(OTP_TIMERS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function getActiveEntry(phone: string, duration: number): TimerEntry | null {
  const entries = getTimerEntries();
  const entry = entries.find((e) => e.phone === phone);

  if (!entry) return null;

  const elapsed = Math.floor((Date.now() - entry.startTime) / 1000);
  return elapsed < duration ? entry : null;
}

export function getRemainingTime(entry: TimerEntry, duration: number): number {
  const elapsed = Math.floor((Date.now() - entry.startTime) / 1000);
  return Math.max(duration - elapsed, 0);
}

export function saveTimerEntry(phone: string): void {
  let entries = getTimerEntries().filter((e) => e.phone !== phone);

  if (entries.length >= MAX_ENTRIES) {
    entries = entries.slice(-MAX_ENTRIES + 1);
  }

  entries.push({ phone, startTime: Date.now() });
  localStorage.setItem(OTP_TIMERS_STORAGE_KEY, JSON.stringify(entries));
}

export function removeTimerEntry(phone: string): void {
  const entries = getTimerEntries().filter((e) => e.phone !== phone);
  localStorage.setItem(OTP_TIMERS_STORAGE_KEY, JSON.stringify(entries));
}

export function getLastActivePhone(duration: number): string | null {
  const entries = getTimerEntries();
  const now = Date.now();

  for (let i = entries.length - 1; i >= 0; i--) {
    const elapsed = Math.floor((now - entries[i].startTime) / 1000);
    if (elapsed < duration) {
      return entries[i].phone;
    }
  }

  return null;
}
